import React from "react"

// Set state passed down from NavBar to open NavBar mobile menu

const NavBarHamburgerMenu = ({ onToggle, light = false }) => {
  return (
    <button
      onClick={() => {
        onToggle()
      }}
      className="nav-bar__btn mobile-menu"
    >
      <div className={`hamburger ${light ? "hamburger--light" : ""}`}>
        <div className="hamburger__bar"></div>
        <div className="hamburger__bar"></div>
        <div className="hamburger__bar"></div>
      </div>
    </button>
  )
}

export default NavBarHamburgerMenu
